<template>
  <span @click="onEmojiClick">{{ emoji.value }}</span>
</template>

<script>
  export default {
    data () {
      return {}
    },
    props: {
      emoji: {
        type: Object
      },
    },
    methods: {
      onEmojiClick () {
        this.$emit('click', this.emoji)
      }
    }
  }
</script>
